import { Button, DownloadIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
import { useDownloadLicenses } from "../../hooks/licenses/useDownloadLicenses";
import { LicencesListFiltersType } from "../../hooks/licenses/LicencesListFiltersType";

type DownloadLicensesButtonProps = {
  licensesFilename: string;
  licencesFilter: LicencesListFiltersType | undefined;

};

export const DownloadLicensesButton: React.FC<DownloadLicensesButtonProps> = ({
  licensesFilename,
  licencesFilter,

}) => {
  const { t } = useTranslation();
  const [downloadLicenses] = useDownloadLicenses(licencesFilter);

  return (
    <Button
      //  disabled={cultureCode === undefined}
      key="licenses-download"
      icon={<DownloadIcon />}
      type="primary"
      onClick={async () => {
        const blob = await downloadLicenses();
        console.log(blob);
        if (blob) {
          saveAs(blob, licensesFilename);
        }
        else {
          console.log("It is not blob");
        }
      }}
    //  loading={isLoading}
    >
      {t("licenses.basic.actions.download.button")}
    </Button>
  );
};
